import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.copyright}>
        © {currentYear} 노후든든. All rights reserved.
      </div>
      <nav className={styles.nav}>
        <Link to="/privacy-policy">개인정보처리방침</Link>
        <Link to="/about">소개</Link>
      </nav>
    </footer>
  );
};
